import PrimarySmall from "./PrimarySmall";

export default PrimarySmall;
export { PrimarySmall as H3 };
